import CargoCompanyAddressListRequest from "../../../../api/raily/cargo-company/address/list/cargo-company-address-list.request";
import CargoCompanyAddressListParams from "./cargo-company-address-list-params";

const create = (
  params: CargoCompanyAddressListParams,
): CargoCompanyAddressListRequest => {
  return {
    companyUuid: params.companyUuid,
    searchQuery: params.searchQuery,
  };
};

const cargoCompanyAddressListParamsFactory = {
  create,
};

export default cargoCompanyAddressListParamsFactory;
